"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePickerDefaults = {
    dateFormat: 'YYYY-MM-DD',
    dateTimeFormat: 'YYYY-MM-DD HH:mm A',
    timeFormat: 'HH:mm A',
    locale: 'en',
};
//# sourceMappingURL=Constant.js.map